export default new class FilterStorageService {

  set(key: string, value: string) {
    localStorage.setItem(`${key}-filter`, value);
  }

  get(key: string) {
    return localStorage.getItem(`${key}-filter`);
  }

  exists(key: string) {
    return !!localStorage.getItem(`${key}-filter`);
  }

  remove(key: string | string[]) {
    if (Array.isArray(key)) {
      key.forEach((k) => localStorage.removeItem(`${k}-filter`));
    } else {
      localStorage.removeItem(`${key}-filter`);
    }
  }
}();
